module.exports = __webpack_public_path__ + "cristmas.ca5608410eecd3438ed6.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/christmas/webfont/cristmas.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/christmas/webfont/cristmas.woff
// module chunks = styles